import { Component, OnInit, Input, Output, HostListener, EventEmitter } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

@Component({
    selector: 'fw-bar-button',
    template: require('./bar-button.component.html'),
    styles: [require('./bar-button.component.css')]
})
export class BarButtonComponent implements OnInit {
    @Input() title: string;
    @Input() clickRoute: string;
    @Input() clickEventType: string;
    @Input() isSmall: boolean;
    @Input() isLogoBtn: boolean;

    @Output() buttonClick = new EventEmitter<any>();

    constructor(private router: Router) { }


    ngOnInit() {
    }

    @HostListener('click', ['$event'])
    onClick(event): void {

        event.stopPropagation();

        if (this.clickEventType == 'navigate') {
            if (this.clickRoute != null) {
                this.router.navigate(['/auth/' + this.clickRoute]);
            }
        }
        else {
            this.buttonClick.emit(this.clickEventType);
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/fw/buttons/bar-button.component.ts